export default __webpack_public_path__ + "static/media/info-white.91a0615a.svg";